<!-- <p>lucky-draw works!</p> -->

<app-customer-header></app-customer-header>

<div class="spin_wheel">
    <p>Member No. <br><input type="text" class="form-control" placeholder="Enter phone number to check tries left" (keyup)="lucky_draw_check_if_phone_exists($event)"> <img loading="lazy"
            src="../../../assets/images/checkmark.png" *ngIf="hideShowCheckMark == 1" class="checkm">
        <!-- <img loading="lazy" src="../../../../assets/images/spinner.gif" class="loader" *ngIf="hideShowLoader == 1"> -->
    </p>
    
    <h5 class="left" *ngIf="hideShowCheckMark == 1 && chancesLeft != 0">{{chancesLeft}} spins available</h5>
    <h5 class="left" *ngIf="hideShowCheckMark == 1 && chancesLeft == 0">No spins available</h5>


    <div id="canvasContainer">
        <canvas height="434" id="canvas" width="434" data-responsiveMinWidth="180" data-responsiveScaleHeight="true"
            data-responsiveMargin="50">
            <p>Sorry, your browser doesn't support canvas. Please try another.</p>
        </canvas>
        <img loading="lazy" id="prizePointer" src="../../../assets/images/basic_pointer.png" alt="V" />
    </div>

    <button (click)="startSpin()" *ngIf="hideShowCheckMark == 1 && chancesLeft != 0">Spin</button>
    <button class="spin_disable" *ngIf="hideShowCheckMark == 0 || chancesLeft == 0">Spin</button>

</div>

<div class="search_details2 ">
    <h2 class="title text-center mb-5">REDEEMED VOUCHERS</h2>
    <div class="container">
        <div class="row rewards_row">
            <div class="col-md-12">
           <ul class="nav nav-tabs" id="myTab2" role="tablist">
               <li class="nav-item">
                 <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Browse</a>
               </li>
               <li class="nav-item">
                 <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">My Rewards ({{rewardList}})</a>
               </li>
             
             </ul>
             <div class="tab-content re_wards_list" id="myTabContent">
               <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                <div class="row mt-1 pt-1">
                    <h5 class="no_reward">Coming soon...</h5>
                </div>
               </div>
               <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                <div class="row mt-1 pt-1">
                    <h5 class="no_reward" *ngIf="hideShowCheckMark == 1 && rewardList == 0">You will get a change to spin after a repair complete</h5>
                    <h5 class="no_reward" *ngIf="hideShowCheckMark == 0">No data found</h5>
                    <div class="col-md-4" *ngFor="let i of lucky_draws">
                        <div class="gifts">
                            <img loading="lazy" src="../../../assets/images/gift_img_blue.png">
                            <p class="">{{ i.luckyDrawOption.innerName }}</p>
                            <a>{{ i.created * 1000 | date: 'medium' }}</a>
                            <p class="claim" *ngIf="i.isClaimed == 0"><button (click)="claim_lucky_draw(i.id)">Claim</button></p>
                            <p class="claimed" *ngIf="i.isClaimed == 1"><button>Claimed</button></p>
                        </div>
                    </div>
                </div> 
                
                
                </div>
             </div>
       </div>
       </div>

    
    </div>

</div>

<app-customer-footer></app-customer-footer>